// client/src/api/deckService.js
import api from './api';

// Obtenir les decks de l'utilisateur
export const getUserDecks = async () => {
  try {
    const response = await api.get('/decks');
    return response.data;
  } catch (error) {
    console.error('Error fetching user decks:', error);
    throw error;
  }
};

// Obtenir un deck par ID
export const getDeck = async (deckId) => {
  try {
    const response = await api.get(`/decks/${deckId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching deck ${deckId}:`, error);
    throw error;
  }
};

// Créer un nouveau deck
export const createDeck = async (deckData) => {
  try {
    const response = await api.post('/decks', deckData);
    return response.data;
  } catch (error) {
    console.error('Error creating deck:', error);
    throw error;
  }
};

// Mettre à jour un deck existant
export const updateDeck = async (deckId, deckData) => {
  try {
    const response = await api.put(`/decks/${deckId}`, deckData);
    return response.data;
  } catch (error) {
    console.error(`Error updating deck ${deckId}:`, error);
    throw error;
  }
};

// Supprimer un deck
export const deleteDeck = async (deckId) => {
  try {
    const response = await api.delete(`/decks/${deckId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting deck ${deckId}:`, error);
    throw error;
  }
};

// R41 : statut des cartes pour le deck classé — escrow marketplace (carte
// listée en vente) + verrou saisonnier (déjà utilisée en classé par un autre
// compte). Une seule requête pour tout le deck.
export const getCardStatus = async (cardIds) => {
  const ids = [...new Set((cardIds || []).map(String))].slice(0, 500);
  if (ids.length === 0) return { cards: {} };
  const response = await api.get(`/marketplace/cards/status?ids=${encodeURIComponent(ids.join(','))}`);
  return response.data;
};